
import router from "../router"
router.beforeEach((to, from, next) => {
    var screenWidth = document.body.clientWidth;
    var path = to.path
    if (screenWidth <= 800) {
        path = path.replace("pc", "mobile");
    } else {
        path = path.replace("mobile", "pc");
    }
    if (screenWidth > 800) {
        path = path.replace("contact", "news");
    }
    if (path!=to.path) {
        next({
            path: path,
            query: to.query
        });
    } else {
        next()
    }
    
    
})